var React = require('react');

function Computer (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M22 1h-20c-1.103 0-2 .898-2 2v15c0 1.103.897 2 2 2h6.806l-.666 2h-3.14c-.276 0-.5.224-.5.5s.224.5.5.5h14c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-3.14l-.667-2h6.807c1.103 0 2-.897 2-2v-15c0-1.102-.897-2-2-2zm-7.194 21h-5.612l.667-2h4.279l.666 2zm8.194-4c0 .552-.449 1-1 1h-20c-.551 0-1-.448-1-1v-15c0-.552.449-1 1-1h20c.551 0 1 .448 1 1v15zM21.5 3h-19c-.276 0-.5.224-.5.5v12c0 .276.224.5.5.5h19c.276 0 .5-.224.5-.5v-12c0-.276-.224-.5-.5-.5zm-.5 12h-18v-11h18v11z","key":0}),React.createElement("circle",{"cx":"12","cy":"17.5","r":"1","key":1})]));
}

Computer.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Computer;

Computer.default = Computer;
